import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ user, isAdminRequired = false }) => {
  // Se não houver usuário logado, manda para o login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Se a rota exigir admin e o usuário não for o admin oficial
  const isAdmin = user.email === process.env.REACT_APP_ADMIN_EMAIL;
  if (isAdminRequired && !isAdmin) {
    return <Navigate to="/dashboard/feed" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
